import React, { useState } from "react";
import awsSES from "../../util/aws-ses";
import { useTranslation } from "react-i18next";

const MailForm = () => {
  const { t } = useTranslation("mailForm");

  const [input, setInput] = useState({
    co_name: "",
    phone: "",
    email: "",
    detail: "",
  });

  const onChange = ({ target }) => {
    const { value, name } = target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const subject = "[ReadyPlay] 문의 메일";

    const { co_name, phone, email, detail } = input;

    if (co_name.length <= 0) {
      window.alert("업체명을 입력해 주세요.");
      return;
    }
    if (phone.length <= 0) {
      window.alert("연락처를 입력해 주세요.");
      return;
    }
    if (email.length <= 0) {
      window.alert("이메일을 입력해 주세요.");
      return;
    }
    if (detail.length <= 0) {
      window.alert("상세 내용을 입력해 주세요.");
      return;
    }

    let detailData = "";

    if (detail?.split("\n")?.length > 0) {
      detail?.split("\n")?.map((line, index) => {
        detailData += `<p>${line || `<br />`}</p>`;
      });
    }

    const message = `
    <div
    id="#CMSmailForm"
    style="
    margin: 0 auto;
      background: #f9f9f9;
      border-radius: 10px;
      overflow: hidden;
    "
  >
    <div
      style="
        width: 100%;
        font-size: 14px;
        padding: 0 40px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
      "
    >
      <div
        style="
          width: fit-content;
          padding: 4rem;
          border-radius: 5px;
          background: #fff;
          margin: 0 auto;
        "
      >
        <div>
          <h1
            id="mail_form--title"
            style="
              text-align: center;
              line-height: 24px;
              font-size: 18px;
              background: #e5e5e5;
              color: #666;
              padding: 1.8rem 2.2rem;
              border-radius: 5px;
              font-weight: 600;
            "
          >
            [readyplay.co.kr]에서 들어온 문의 입니다.
          </h1>
          <div>
            <h2 style="margin: 50px 0 20px; color: #666">문의 내용</h2>
            <table
              style="
                font-size: 14px;
                width: 100%;
                border: 1px solid #999;
                border-collapse: collapse;
                margin: 0 auto;
                margin-top: 20px;
                margin-bottom: 40px;
                color: #666;
                background: #fff;
              "
            >
              <colgroup>
                <col width="30%" />
                <col width="70%" />
              </colgroup>
              <tbody>
                <tr>
                  <th
                    style="
                      text-align: center;
                      border: 1px solid #e5e5e5;
                      padding: 10px;
                      font-size: 16px;
                      background-color: #f9f9f9;
                    "
                  >
                    업체명
                  </th>
                  <td style="border: 1px solid #e5e5e5; padding: 10px">
                    ${co_name}
                  </td>
                </tr>
                <tr>
                  <th
                    style="
                      text-align: center;
                      border: 1px solid #e5e5e5;
                      padding: 10px;
                      font-size: 16px;
                      background-color: #f9f9f9;
                    "
                  >
                    연락처
                  </th>
                  <td style="border: 1px solid #e5e5e5; padding: 10px">
                    ${phone}
                  </td>
                </tr>
                <tr>
                  <th
                    style="
                      text-align: center;
                      border: 1px solid #e5e5e5;
                      padding: 10px;
                      font-size: 16px;
                      background-color: #f9f9f9;
                    "
                  >
                    Email
                  </th>
                  <td style="border: 1px solid #e5e5e5; padding: 10px">
                    ${email}
                  </td>
                </tr>
                <tr>
                  <th
                    style="
                      text-align: center;
                      border: 1px solid #e5e5e5;
                      padding: 10px;
                      font-size: 16px;
                      background-color: #f9f9f9;
                      
                    "
                  >
                    상세내용
                  </th>
                  <td style="border: 1px solid #e5e5e5; padding: 10px;">
                    ${detailData}
                  </td>
                </tr>
              </tbody>
              </table>
            <p
              style="
                color: #999;
                font-size: 13px;
                line-height: 21px;
                padding-left: 5px;
              "
            >
              &#8251; 본 메일은 발신 전용이며, 회신 되지 않습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    `;
    try {
      awsSES.sendEmail(subject, message);
    } catch (e) {
      window.alert("메일 전송을 실패하였습니다.");
      return;
    }
    window.alert("문의 내용이 정상적으로 전송 되었습니다.");
    setInput({
      co_name: "",
      phone: "",
      email: "",
      detail: "",
    });
  };

  return (
    <section className="proposal container fade-up" id="contact">
      <div className="inner">
        <h2 className="main-tit md">
          <b>Contact</b>
        </h2>
        <p className="desc">
          <b>{t("address")} | repl@salin.co.kr</b>
          {t("phrase_01")}
          <br />
          {t("phrase_02")}
        </p>
        <form onSubmit={onSubmit}>
          <div className="contact-form">
            <div className="col">
              <label htmlFor="co_name">{t("co_name")}</label>
              <input
                type="text"
                name="co_name"
                id="co_name"
                value={input?.co_name || ""}
                onChange={onChange}
              />
            </div>
            <div className="col">
              <label htmlFor="phone">{t("poc")}</label>
              <input
                type="phone"
                name="phone"
                id="phone"
                value={input?.phone || ""}
                onChange={onChange}
              />
            </div>
            <div className="col">
              <label htmlFor="email">{t("email")}</label>
              <input
                type="email"
                name="email"
                id="email"
                value={input?.email || ""}
                onChange={onChange}
              />
            </div>
            <div className="col">
              <label htmlFor="datail">{t("detail")}</label>
              <textarea
                name="detail"
                id="detail"
                cols="30"
                rows="10"
                value={input?.detail || ""}
                onChange={onChange}
              ></textarea>
            </div>
          </div>
          <input type="submit" value="Contact Us " className="btn-full" />
        </form>
      </div>
    </section>
  );
};

export default MailForm;
